export default {
  // プログラム管理ページ
  title: {
    en: 'Program Management',
    ja: '番組表管理',
  },

  // テーブルヘッダー
  table: {
    id: {
      en: 'ID',
      ja: 'ID',
    },
    startTime: {
      en: 'Start Time',
      ja: '開始時間',
    },
    endTime: {
      en: 'End Time',
      ja: '終了時間',
    },
    duration: {
      en: 'Duration (seconds)',
      ja: '再生時間(秒)',
    },
    supplier: {
      en: 'Supplier',
      ja: 'サプライヤー',
    },
    actions: {
      en: 'Actions',
      ja: '操作',
    },
  },

  // タイトル
  titles: {
    edit: {
      en: 'Edit Program',
      ja: '番組表編集',
    },
    create: {
      en: 'Create New Program',
      ja: '番組表新規作成',
    },
    batchCreate: {
      en: 'Batch Create Programs',
      ja: '番組表一括作成',
    },
  },

  // ボタン
  buttons: {
    newProgram: {
      en: 'New Program',
      ja: '新規番組表',
    },
    batchCreate: {
      en: 'Batch Create',
      ja: '一括作成',
    },
    backToList: {
      en: 'Back to Program List',
      ja: '番組表一覧に戻る',
    },
  },

  // フォーム
  form: {
    startDate: {
      en: 'Start Date',
      ja: '開始日時',
    },
    duration: {
      en: 'Duration (seconds)',
      ja: '再生時間（秒）',
    },
    supplier: {
      en: 'Supplier',
      ja: 'サプライヤー',
    },
    endDate: {
      en: 'End Date',
      ja: '終了日時',
    },
    player: {
      en: 'Player',
      ja: 'プレイヤー',
    },
    date: {
      en: 'Date',
      ja: '日付',
    },
    timeRangeSettings: {
      en: 'Time Range Settings',
      ja: '時間範囲の設定',
    },
    timeRangeDescription: {
      en: 'Programs will be registered at these minutes every hour. If end minute is 0, it means 0 minute of the next hour (crossing hour). Duration is automatically calculated from start and end minutes.',
      ja: '毎時この分数に番組表が登録されます。終了分が0の場合は、次の時間の0分を意味します（時間またぎ）。再生時間は開始分と終了分から自動計算されます。',
    },
    startMinute: {
      en: 'Start Minute (0-59)',
      ja: '開始分（0-59）',
    },
    endMinute: {
      en: 'End Minute (0-59, 0 means 0 minute of next hour)',
      ja: '終了分（0-59、0の場合は次の時間の0分）',
    },
    calculatedDuration: {
      en: 'Calculated duration: {{duration}} seconds',
      ja: '計算される再生時間: {{duration}}秒',
    },
  },

  // バリデーション
  validation: {
    startDateRequired: {
      en: 'Start date is required',
      ja: '開始日時は必須です',
    },
    durationRequired: {
      en: 'Duration is required',
      ja: '再生時間は必須です',
    },
    durationNumeric: {
      en: 'Duration must be a non-negative integer',
      ja: '再生時間は非負整数で入力してください',
    },
    durationPositive: {
      en: 'Duration must be greater than 0',
      ja: '再生時間は0より大きい値を入力してください',
    },
    supplierRequired: {
      en: 'Supplier is required',
      ja: 'サプライヤーは必須です',
    },
    dateRequired: {
      en: 'Date is required',
      ja: '日付は必須です',
    },
    startMinuteRequired: {
      en: 'Start minute is required',
      ja: '開始分は必須です',
    },
    startMinuteRange: {
      en: 'Start minute must be between 0 and 59',
      ja: '開始分は0～59の範囲で入力してください',
    },
    endMinuteRequired: {
      en: 'End minute is required',
      ja: '終了分は必須です',
    },
    endMinuteRange: {
      en: 'End minute must be between 0 and 59',
      ja: '終了分は0～59の範囲で入力してください',
    },
    endMinuteZero: {
      en: 'If start and end minutes are the same, end minute must be 0 (crossing hour)',
      ja: '開始分と終了分が同じ場合、終了分は0にしてください（時間またぎ）',
    },
  },

  // メッセージ
  messages: {
    searchPlaceholder: {
      en: 'Search programs...',
      ja: '番組表を検索...',
    },
    noPrograms: {
      en: 'No programs found',
      ja: '該当する番組表が見つかりません',
    },
    deleteTitle: {
      en: 'Delete Program',
      ja: '番組表の削除',
    },
    deleteConfirm: {
      en: 'Are you sure you want to delete this program? This action cannot be undone.',
      ja: 'この番組表を削除してもよろしいですか？この操作は元に戻せません。',
    },
    deleteSuccess: {
      en: 'Program deleted successfully',
      ja: '番組表を削除しました',
    },
    updateSuccess: {
      en: 'Program updated successfully',
      ja: '番組表を更新しました',
    },
    createSuccess: {
      en: 'Program created successfully',
      ja: '番組表を作成しました',
    },
    programNotFound: {
      en: 'Program not found',
      ja: '番組表が見つかりませんでした',
    },
    batchCreateSuccess: {
      en: '{{count}} programs created successfully',
      ja: '{{count}}件の番組表を作成しました',
    },
  },
};
